<template>
  <div
      v-if="workflowStatus === 0"
      class="w-100">

    <form v-if="showWashingTime" v-show="canWrite" @submit.prevent="saveWashed">

      <div v-if="showWashingTime" class="row">
        <h2 class="mb-3">Waschen</h2>
        <div class="col-4"><h6>Start</h6></div>
        <date-input input-id="washedStartDate" v-model="washedStartDate"></date-input>
        <time-input input-id="washedStartTime" v-model="washedStartTime"></time-input>

        <div class="col-4 mt-2"><h6>Ende</h6></div>
        <date-input input-id="washedDate" v-model="washedDate"></date-input>
        <time-input input-id="washedTime" v-model="washedTime"></time-input>

      </div>
      <div v-if="isAppCollectionPoint" class="row">
        <div class="input-group form-check mt-4 mb-3">
          <input v-model="washedSystemCleaned" type="checkbox" class="form-check" id="washedSystemCleaned">
          <label class="form-check-label ml-2" for="washedSystemCleaned">Anlage gereinigt</label>
        </div>
        <div class="input-group form-check mb-3">
          <input v-model="washedContainersCleaned" type="checkbox" class="form-check" id="washedContainersCleaned">
          <label class="form-check-label ml-2" for="washedContainersCleaned">Container gereinigt</label>
        </div>
      </div>

      <div v-if="washingStored" class="col-8 mt-3 text-right">
        <img class="opened" src="@/assets/images/icon-done.svg"/>
        gespeichert
      </div>
      <button @click="storeWashing" class="mt-3 mb-3" type="button">Zwischenspeichern</button>
    </form>

    <h2>Nassbehälter</h2>
    <div
        v-if="getWetVessels().length">
      <ul class="output">
        <li
            v-for="bag in getWetVessels()"
            :key="bag.vesselId">
          <label class="col-4">{{ bag.number ? 'Container '+ bag.number : bag.uniqueNumber }}</label> {{ globalFunctions.parseNumber(bag.weight) }} kg
          <button v-show="canWrite" @click="openDialog(
              { element: 'der Nassbehälter',nbr: bag.uniqueNumber, weight: bag.weight, number: bag.number, uid: bag.uniqueId})"
                  class="del">-
          </button>
        </li>
      </ul>
    </div>

    <form v-show="canWrite" @submit.prevent="saveBag"
          class="row" ref="wetVesselNumber">
      <!-- todo: only for app-type sammelstelle -->
      <div class="input-group col-6 mb-3">
        <div class="input-group-prepend">
          <label class="input-group-text" for="wetNumber">Nummer</label>
        </div>
        <input v-model="wetNumber" type="number" step="1" class="form-control form-control-lg"
               id="wetNumber" placeholder="">
      </div>
      <button @click.prevent="showBarcodeReader" class="col-2 mt-0 mb-3 pt-0 pb-0" style="text-align: center"><img src="@/assets/images/icon-barcode-scan.svg" style="float:unset" width="32" height="32"/></button>
      <div class="input-group col-6">
        <div class="input-group-prepend">
          <label class="input-group-text" for="wetWeight">Nass</label>
        </div>
        <input v-model="wetWeight" type="number" step="0.1" class="form-control form-control-lg"
               id="wetWeight" placeholder="">
        <div class="input-group-append">
          <span class="input-group-text">kg</span>
        </div>
      </div>
      <button class="col-2 mt-0 mb-0 pt-0 pb-0" type="submit" style="text-align: center">+</button>
    </form>
    <div
        v-if="getWetVessels().length">
      <h2>Nassgewicht</h2>
      <ul class="output">
        <li class="bold">
          <label class="col-2 bold">Gesamt</label> {{ totalWeight(1) }} kg
        </li>
      </ul>
    </div>

    <workflow-notes :note-data="noteData" :can-write="canWrite"/>
    <div v-if="storing" class="col-8 mt-3 text-center">
      Die Daten werden gespeichert...
    </div>
    <div>
      <button v-show="canWrite" @click="finishWashing" type="button" class="done" :disabled="storing">Abschluss</button>
    </div>
  </div>
  <div
      v-else-if="workflowStatus === 1"
      class="w-100">

    <div v-if="dryingDryerId && (vesselsOnDryer().length || vesselsToDry().length)">
      <h2>Nassbehälter auf Trockner</h2>
      <div v-if="vesselsOnDryer()" class="w-100 mt-2">
        <div class="mb-4">
          <ul class="output">
            <li
                v-for="bag in vesselsOnDryer()"
                :key="bag.vesselId">
              <label class="col-4">{{ bag.number ? 'Container '+ bag.number : bag.uniqueNumber }}</label>
              {{ globalFunctions.parseNumber(bag.weight) }} kg
            </li>
          </ul>
        </div>
      </div>
      <form v-show="canWrite && vesselsToDry().length" @submit.prevent="addVesselToDryer" class="row">
        <div class="input-group col-6">
          <select v-model="wetVesselId"
                  class="custom-select custom-select-lg" id="wetVesselId">
            <option value="0">Auswählen...</option>
            <option
                v-for="(item) in vesselsToDry()"
                :key="item.vesselId"
                :value="item.vesselId">{{ item.number ? 'Container '+ item.number : item.uniqueNumber }}</option>
          </select>
        </div>
        <button class="col-2 mt-0 mb-0 pt-0 pb-0" type="submit" style="text-align: center">+</button>
      </form>
    </div>

    <div v-show="workflowState == 30 && (!dryingDryerId || (dryingDryerId && vesselsOnDryer().length))">
      <h2 class="mb-3">Trocknung</h2>
      <form v-show="canWrite" @submit.prevent="saveDried" class="row">

        <div v-if="dryersAmount > 1 && !dryingDryerId" class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dryerId">Trockner</label>
          </div>
          <select v-if="dryers"
                  v-model="dryerId"
                  class="custom-select custom-select-lg" id="dryerId">
            <option
                v-for="(item,index) in dryers"
                :key="index"
                :value="index">{{ item }}</option>
          </select>
          <select v-else
              v-model="dryerId"
              class="custom-select custom-select-lg" id="dryerId">
            <option
                v-for="index in dryersAmount"
                :key="index"
                :value="index">Trockner {{ index }}
            </option>
          </select>
        </div>

        <div class="input-group col-8 mb-3" v-if="showDryingTemperature">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dryingTemperature">Temperatur</label>
          </div>
          <input  v-model="dryingTemperature" type="number" step="1" class="form-control form-control-lg"
                 id="dryingTemperature" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">°</span>
          </div>
        </div>
        <div class="input-group col-8 mb-3" v-if="showDriedMoundHeight">
          <div class="input-group-prepend">
            <label class="input-group-text" for="driedMoundHeight">Aufschütthöhe</label>
          </div>
          <input  v-model="driedMoundHeight" type="number" step="1" class="form-control form-control-lg"
                 id="driedMoundHeight" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">cm</span>
          </div>
        </div>
        <div v-if="showDryingStartTime || showDryingHeatMeter" class="col-4"><h6>Start</h6></div>
        <date-input v-if="showDryingStartTime" v-model="driedStartDate" input-id="driedStartDate" mb="0"></date-input>
        <time-input v-if="showDryingStartTime" v-model="driedStartTime" input-id="driedStartTime" mb="0"></time-input>

        <div v-if="showDryingStartMoisture" class="input-group col-8 mb-0 mt-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="driedStartMoisture">Feuchtigkeit</label>
          </div>
          <input v-model="driedStartMoisture" type="number" step=".01" class="form-control form-control-lg"
                 id="driedStartMoisture" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div class="input-group col-8 mb-2 mt-3" v-if="showDryingHeatMeter">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dryingHeatMeterStart">Wärmezähler-Stand</label>
          </div>
          <input  v-model="dryingHeatMeterStart" type="number" step="1" class="form-control form-control-lg"
                  id="dryingHeatMeterStart" placeholder="">
        </div>

        <div v-if="showDryingStartTime || showDryingHeatMeter" class="col-4 mt-2"><h6>Ende</h6></div>
        <date-input v-model="driedDate" input-id="driedDate" mb="0"></date-input>
        <time-input v-model="driedTime" input-id="driedTime" mb="0"></time-input>

        <div v-if="!sampleDriedOnFilling" class="input-group col-8 mb-3 mt-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="driedMoisture">Feuchtigkeit</label>
          </div>
          <input v-model="driedMoisture" type="number" step=".01" class="form-control form-control-lg"
                 id="driedMoisture" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">%</span>
          </div>
        </div>
        <div v-if="!sampleDriedOnFilling" class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="driedHlWeight">HL-Gewicht</label>
          </div>
          <input v-model="driedHlWeight" type="number" step=".01" class="form-control form-control-lg"
                 id="driedHlWeight" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>

        <div class="input-group col-8 mb-3 mt-3" v-if="showDryingHeatMeter">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dryingHeatMeterEnd">Wärmezähler-Stand</label>
          </div>
          <input v-model="dryingHeatMeterEnd" type="number" step="1" class="form-control form-control-lg"
                  id="dryingHeatMeterEnd" placeholder="">
        </div>
        <div v-if="!sampleDriedOnFilling" class="input-group col-8 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="driedSampleNumber">Probe Nr</label>
          </div>
          <input v-model="driedSampleNumber" class="form-control form-control-lg"
                  id="driedSampleNumber" placeholder="">
        </div>
        <div class="input-group form-check mb-3">
          <input v-model="dryerCleaned" type="checkbox" class="form-check" id="dryerCleaned">
          <label class="form-check-label ml-2" for="dryerCleaned">Trockner gereinigt</label>
        </div>
      </form>

      <workflow-notes :note-data="noteData" :can-write="canWrite"/>

      <div v-if="canWrite" class="w-100">
        <div v-if="storing" class="col-8 mt-3 text-center">
          Die Daten werden gespeichert...
        </div>
        <div v-if="dryingStored" class="col-8 mt-3 text-right">
          <img class="opened" src="@/assets/images/icon-done.svg"/>
          gespeichert
        </div>
        <button @click="storeDrying" class="mt-3 mb-3" type="button" :disabled="storing">Zwischenspeichern</button>
        <button @click="finishDrying" type="button" class="done" :disabled="storing">Abschluss</button>
      </div>

    </div>

    <div v-if="workflowState == 50">

      <h1 id="crud-vessels">{{ batch.productId > 1 ? 'Einlagern' : 'Big Bags' }}</h1>
      <div class="mb-4">
        <ul class="output">
          <li
              v-for="bag in getDryVessels()"
              :key="bag.vesselId">
            <button v-show="canWrite" @click="openDialog(
                { element: 'der Big Bag',nbr: bag.uniqueNumber, weight: bag.weight, number: bag.number, uid: bag.uniqueId})"
                    class="del">-
            </button>
            <b class="col-2">{{ bag.number ? (bag.isBigBag ? 'BB ' : 'C ')+ bag.number : bag.uniqueNumber }}</b> {{ parseNumber(bag.weight) }} kg
            <br v-if="bag.regraterId != batch.regraterId"/>
            <label v-if="bag.regraterId != batch.regraterId" class="offset-1">&uarr; {{ regraterName(bag.regraterId) }}</label>
            <br v-if="bag.stockLocation"/>
            <label v-if="bag.stockLocation">Lager {{ bag.stockLocation }}</label>
            <button v-show="canWrite" @click="editBag(bag)" class="edit">~</button>
            <api-pdf-link method="bigbagslip"
                          @openedPdf="openedPdf"
                          :elementId="bag.uniqueId" :opened="parseInt(bag.openedBigBagSlip)" class="float-right"/>
          </li>
        </ul>
      </div>

      <form v-show="canWrite" @submit.prevent="saveForm"
            class="row">
        <div class="input-group col-8 mb-3 required">
          <div class="input-group-prepend">
            <label class="input-group-text" for="vessel_regraterId">Aufkäufer</label>
          </div>
          <select
              v-model="vessel_regraterId" @change="getFillableVessels"
              class="custom-select custom-select-lg" id="vessel_regraterId">
            <option value="">Auswählen..</option>
            <option
                v-for="regrater in regraters"
                :key="regrater.contactId"
                :value="regrater.contactId">{{ regrater.name }}
            </option>
          </select>
        </div>
        <div class="input-group col-8 mb-3" v-if="showStockLocation">
          <div class="input-group-prepend">
            <label class="input-group-text" for="stockLocation">Lagerort</label>
          </div>
          <input v-model="stockLocation" type="string" step=".01" class="form-control form-control-lg"
                 id="stockLocation" placeholder="">
        </div>
        <!--div class="input-group col-6 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="containerNumber">Container</label>
          </div>
          <input v-model="containerNumber" type="number" step="1" class="form-control form-control-lg"
                 id="containerNumber" placeholder="">
        </div-->
        <div class="input-group col-6 mb-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dryNumber">BB-Nummer</label>
          </div>
          <input v-model="dryNumber" type="number" step="1" class="form-control form-control-lg"
                 id="dryNumber" placeholder="">
        </div>
        <button
            class="col-2 mt-0 mb-3 pt-0 pb-0 icon"
            @click="getBbBarcodeNumber">
          <img class="opened" src="@/assets/images/icon-barcode-scan.svg"/>
        </button>

        <div class="input-group col-6 required">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dryWeight">Trocken</label>
          </div>
          <input v-model="dryWeight" type="number" step=".01" class="form-control form-control-lg"
                 id="dryWeight" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>
        <button
            v-if="hasBbScale"
            class="col-2 mt-0 mb-0 pt-0 pb-0 icon"
            @click="getWeightFromBbScale">
          <img class="opened" src="@/assets/images/icon-weight.svg"/>
        </button>
        <div v-if="scaleData.output" class="input-group col-8 mt-2 pl-3">
          {{ scaleData.output }}
        </div>
        <div v-if="scaleData.error" class="input-group col-8 mt-2 pl-3 alert-error" v-html="scaleData.error"/>

        <div v-if="hasBbScale"
             class="input-group col-3 mt-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dryWeightTara">Tara</label>
          </div>
          <input v-model="dryWeightTara" type="number" step=".01" class="form-control form-control-lg"
                 id="dryWeightTara" placeholder="">
        </div>
        <div v-if="hasBbScale"
             class="input-group col-5 mt-3">
          <div class="input-group-prepend">
            <label class="input-group-text" for="dryWeightBrutto">Brutto</label>
          </div>
          <input v-model="dryWeightBrutto" type="number" step=".01" class="form-control form-control-lg"
                 id="dryWeightBrutto" placeholder="">
          <div class="input-group-append">
            <span class="input-group-text">kg</span>
          </div>
        </div>

        <div v-if="useContractPressing">
          <div class="input-group form-check mt-3 mb-3">
            <input v-model="contractPressing" type="checkbox" class="form-check" id="contractPressing">
            <label class="form-check-label ml-2" for="contractPressing">Lohnpressung</label>
          </div>
        </div>

        <button class="col-8 mt-4 mb-0" type="submit" style="text-align: center" @click="saveBag">+ Hinzufügen</button>
        <details
            v-show="batch.productId == 1"
            class="col-8" :open="vessel_parentForm">
          <summary><h2>Big Bag auffüllen</h2></summary>
          <select
              v-model="parent_vesselId"
              class="custom-select custom-select-lg" id="parent_vesselId"
          >
            <option value="">Auswählen...</option>
            <option
                v-for="parent in fillableVessels"
                :key="parent.vesselId"
                :value="parent.uniqueId">{{ parent.uniqueNumber }} {{ parseNumber(parent.weight) }} kg
            </option>
          </select>
        </details>

        <section v-if="sampleDriedOnFilling" class="w-100">
          <h2>Rückstellmuster</h2>
          <div class="input-group col-8 mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="driedSampleNumber">Probe Nr</label>
            </div>
            <input v-model="driedSampleNumber" class="form-control form-control-lg"
                   id="driedSampleNumber" placeholder="">
          </div>
          <div class="input-group col-8 mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="driedMoisture">Feuchtigkeit</label>
            </div>
            <input v-model="driedMoisture" type="number" step=".01" class="form-control form-control-lg"
                   id="driedMoisture" placeholder="">
            <div class="input-group-append">
              <span class="input-group-text">%</span>
            </div>
          </div>

          <div class="input-group col-8 mb-3">
            <div class="input-group-prepend">
              <label class="input-group-text" for="driedHlWeight">HL-Gewicht</label>
            </div>
            <input v-model="driedHlWeight" type="number" step=".01" class="form-control form-control-lg"
                   id="driedHlWeight" placeholder="">
            <div class="input-group-append">
              <span class="input-group-text">kg</span>
            </div>
          </div>
        </section>

      </form>

    </div>

    <div
        v-if="getDryVessels().length">
      <h2>Trockengewicht</h2>
      <ul class="output">
        <li class="bold">
          <label class="col-4 bold">Gesamt</label> {{ totalWeight(2) }} kg
        </li>
      </ul>
      <button v-show="canWrite" @click="finishFilling" type="button" class="done">Abschluss</button>
    </div>
  </div>


  <div v-if="workflowState == 30 && workflowStatus === 2" class="row">
    <div class="col-8">Trockung abgeschlossen.</div>
  </div>

  <div
      v-else-if="(workflowStatus === 2 || workflowState >= 60) && getDryVessels().length" class="w-100">

    <!-- todo: show output of drying data
    <div v-if="this.dryingDryerId" class="row">
      <ul class="output">
        <li v-if="showDryingTemperature">{{ dryingTemperature }}</li>
      </ul>
    </div-->

    <h2 id="vessels">Big Bags<!-- / Container--></h2>
    <div
        v-if="getDryVessels().length">
      <ul class="output">
        <li
            v-for="bag in getDryVessels()"
            :key="bag.vesselId">
          <b class="col-3">{{ bag.number ? (bag.isBigBag ? 'BB ' : 'C ')+ bag.number : bag.uniqueNumber }}</b> {{ parseNumber(bag.weight) }} kg
          <label v-if="getChildVesselsText(bag.vesselId)">+ {{ getChildVesselsText(bag.vesselId) }}</label>
          <br v-if="bag.regraterId != batch.regraterId"/>
          <label v-if="bag.regraterId != batch.regraterId">&uarr; {{ regraterName(bag.regraterId) }}</label>
          <br v-if="bag.stockLocation"/>
          <label v-if="bag.stockLocation">Lager {{ bag.stockLocation }}</label>
          <button v-show="canWrite" @click="editBag(bag)" class="edit">~</button>
          <api-pdf-link method="bigbagslip"
                        @openedPdf="openedPdf"
                        :elementId="bag.uniqueId" :opened="parseInt(bag.openedBigBagSlip)" class="float-right"/>
        </li>
      </ul>
    </div>
    <form @submit.prevent="saveBag"
          class="row">
    </form>
  </div>

  <div v-if="loadedVessels.length" class="w-100">
    <h2 class="pt-0">Verladen</h2>
    <div>
      <ul class="output">
        <li
            v-for="bag in loadedVessels"
            :key="bag.vesselId">
          <b class="col-3">{{ bag.number ? (bag.isBigBag ? 'BB ' : 'C ')+ bag.number : bag.uniqueNumber }}</b> {{ parseNumber(bag.weight) }} kg
          <label v-if="getChildVesselsText(bag.vesselId)">+ {{ getChildVesselsText(bag.vesselId) }}</label>
          <br v-if="bag.regraterId != batch.regraterId"/>
          <label v-if="bag.regraterId != batch.regraterId">&uarr; {{ regraterName(bag.regraterId) }}</label>
          <br v-if="bag.stockLocation"/>
          <label v-if="bag.stockLocation">Lager {{ bag.stockLocation }}</label>
          <api-pdf-link method="bigbagslip"
                        @openedPdf="openedPdf"
                        :elementId="bag.uniqueId" :opened="parseInt(bag.openedBigBagSlip)" class="float-right"/>
        </li>
      </ul>
    </div>
  </div>

  <app-modal-dialog v-if="modalOpened" @abortDialog="abortDialog" @confirmDialog="confirmDialog">
    <h1>Löschen bestätigen</h1>
    <div class="w-100">{{ modalText }}</div>
    <div class="w-100"><strong>{{ modalElement }}</strong></div>
  </app-modal-dialog>
  <popup-bag-editor v-if="bagEditorOpened"
      :element="bagElement" :regraters="regraters" :show-stock-location="showStockLocation" :workflow-state="workflowState"
      @abortDialog="abortBagEdit" @confirmDialog="saveBagEdit"></popup-bag-editor>
  <!--app-qr-reader v-if="barcode" :doEmit="true" @qrRead="barcodeRead"/-->
  <app-barcode-reader v-if="barcode" :doEmit="true" @barcodeRead="barcodeRead"/>

  <app-barcode-reader v-if="scanBbBarcode" :doEmit="true" @barcodeRead="bbBarcodeRead"/>

  <!--  <div-->
  <!--      v-else-if="workflowStatus === 1"-->
  <!--      class="row">-->
  <!--    <h2>Big Bags</h2>-->
  <!--    <form @submit.prevent="save" class="col-8">-->
  <!--      &lt;!&ndash;      <input name="formName" value="dry" type="hidden"/>&ndash;&gt;-->
  <!--      <div class="input-group mb-3">-->
  <!--        <div class="input-group-prepend">-->
  <!--          <label class="input-group-text" for="weight">Gewicht</label>-->
  <!--        </div>-->
  <!--        <input v-model="weight" type="number" class="form-control form-control-lg"-->
  <!--               id="weight" placeholder="">-->
  <!--        <div class="input-group-append">-->
  <!--          <span class="input-group-text">kg</span>-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      <button type="submit">Hinzufügen</button>-->
  <!--    </form>-->
  <!--  </div>-->
</template>

<script>
import { inject } from 'vue'
import ApiPdfLink from "@/components/ApiPdfLink";
import AppModalDialog from "@/components/AppModalDialog";
import dayjs from "dayjs";
import PopupBagEditor from "@/components/PopupBagEditor";
import AppBarcodeReader from "@/components/AppBarcodeReader.vue";
import WorkflowNotes from "@/components/WorkflowNotes.vue";
import { getWeightFromScale } from "@/utils/scaleWeighing";
import TimeInput from "@/components/form/TimeInput.vue";
import DateInput from "@/components/form/DateInput.vue";

export default {
  name: "BagList",
  components: {
    DateInput,
    TimeInput,
    WorkflowNotes,
    AppBarcodeReader, PopupBagEditor, AppModalDialog, ApiPdfLink
  },
  data() {
    return {
      activeBags: [...this.bags],
      weight: null,
      wetWeight: null,
      wetNumber: null,
      dryWeight: null,
      dryWeightTara: null,
      dryWeightBrutto: null,
      dryNumber: null,
      containerNumber: null,
      contractPressing: false,
      noteQuality: '',
      noteImage: '',
      sampleNumber: '',
      modalOpened: false,
      modalText: '',
      modalElement: '',
      modalUid: '',
      dryerId: 1,
      washedStartDate: '',
      washedStartTime: '',
      washedDate: '',
      washedTime: '',
      washedSystemCleaned: false,
      washedContainersCleaned: false,
      washingStored: false,
      dryingTemperature: null,
      dryingHeatMeterStart: null,
      dryingHeatMeterEnd: null,
      driedStartTime: '',
      driedStartDate: '',
      driedStartMoisture: null,
      driedDate: '',
      driedTime: '',
      driedMoisture: null,
      driedHlWeight: null,
      dryerCleaned: true,
      driedSampleNumber: '',
      noteData: {
        text: '',
        images: null,
      },
      dryingStored: false,
      bagElement: null,
      bagEditorOpened: false,
      vessel_regraterId: '',
      vessel_parentForm: false,
      fillableVessels: [],
      parent_vesselId: '',
      driedMoundHeight: '',
      stockLocation: '',
      barcode: false,
      wetVesselId: 0,
      dryVessels: [],
      loadedVessels: [],
      globalFunctions: inject('globalFunctions'),
      scaleData: {},
      scanBbBarcode: false,
      storing: false,
    }
  },
  props: {
    batch: {
      type: Object,
      required: true
    },
    bags: {
      type: Array,
      required: true
    },
    workflowState: {
      type: Number,
      required: false
    },
    workflowStatus: {
      type: Number,
      required: false
    },
    canWrite: {
      type: Boolean,
      default: false
    },
    regraters: {
      type: Array,
      required: true
    },
    elementValue: {
      type: Boolean,
      required: false
    },
    dryingDryerId: {
      type: Number,
      required: false
    },
    wetVessels: {
      type: Array,
      required: false
    },
    dryingList: {
      type: Array,
      required: false
    }
  },
  async created() {
    const batch = this.$props.batch

    // console.log('----- create (baglist)', this.workflowStatus, this.workflowState, this.canWrite, this.dryingDryerId, batch)

    switch (this.workflowStatus) {
      case 0:
        if (this.showWashingTime) {
          // console.log('----',batch.washedStartDateTime)
          this.setWashedStartDateTime(batch.washedStartDateTime)

          if (batch.washedDateTime) {
            this.setWashedDateTime(batch.washedDateTime)
          } else if (batch.washedStartDateTime)
            this.setWashedDateTime()
        }
        this.washedSystemCleaned = batch.washedSystemCleaned == 1
        this.washedContainersCleaned = batch.washedContainersCleaned == 1
        break;
      case 1:
        // this.initDryingData()
        if (this.dryingDryerId > 0) {
          await this.loadDryVessels()
        } else if (this.workflowState == 30)
          this.dryerId = batch.dryerId > 0 ? batch.dryerId : 1
        break

      case 2:
        if (this.workflowState <= 50)
          this.childVessels = await this.$store.dispatch('getItemsByParent', {
            entityName: 'vessel',
            method: 'childs',
            parentEntity: 'batch',
            parentId: batch.batchId,
            returnData: true
          })
        else this.childVessels = []
          
        if (!this.$props.bags.length && !this.dryVessels.length) {
          this.dryVessels = await this.$store.dispatch('getItemsByParent', {
            entityName: 'vessel', parentEntity: 'batch',
            parentId: batch.batchId, method: 'dried',
            returnData: true
          }) ?? []
        }

        // console.log('childsByParent', this.childVessels)
        break
    }
    if (this.workflowState === 50 && batch.driedSampleNumber) {
      this.driedSampleNumber = batch.driedSampleNumber
      this.driedMoisture = batch.driedMoisture
      this.driedHlWeight = batch.driedHlWeight
    }
    if (this.workflowStatus === 2 && (!this.workflowState || this.workflowState > 50))
      this.loadedVessels = await this.$store.dispatch('getItemsByParent', {
        entityName: 'vessel', parentEntity: 'batch',
        parentId: this.batch.batchId, method: 'getLoaded',
        returnData: true
      }) ?? []
  },
  computed: {
    showBatchSampleNumber() {
      return this.$store.getters.batchSampleNumber
    },
    dryersAmount() {
      //return 3
      return this.$store.getters.dryersAmount
    },
    dryers() {
      return this.$store.getters.dryers
    },
    showWashingTime() {
      //return false
      return this.$store.getters.washingTime
    },
    showDryingTemperature() {
      //return true
      return this.$store.getters.dryingTemperature
    },
    showDryingHeatMeter() {
      //return true
      return this.$store.getters.dryingHeatMeter
    },
    showDriedMoundHeight() {
      //return true
      return this.$store.getters.dryingMoundHeight
    },
    showDryingStartTime() {
      //return false
      return this.$store.getters.dryingStartTime
    },
    showDryingStartMoisture() {
      //return true
      return this.$store.getters.dryingStartMoisture
    },
    showStockLocation() {
      return this.$store.getters.vesselStockLocation
    },
    currentDryerId() {
      return this.batch?.dryerId;
    },
    isAppCollectionPoint() {
      return this.$store.getters.appCollectionPoint
    },
    hasBbScale() {
      return this.$store.getters.scaleBbType !== null
    },
    scaleBbHost() {
      return this.$store.getters.scaleBbHost
    },
    useContractPressing() {
      return this.$store.getters.contractPressing
    },
    sampleDriedOnFilling() {
      return this.$store.getters.sampleDriedOnFilling
    },
  },
  methods: {
    async initDryingData(data) {
      // console.log('initDryingData', this.dryingDryerId, data)
      const batch = data ?? this.$props.batch

      //if (batch.dryerId)
        this.dryerId = batch.dryerId ?? 1
      //if (batch.dryingTemperature)
        this.dryingTemperature = parseFloat(batch.dryingTemperature) > 0 ? batch.dryingTemperature : ''
      //if (batch.dryingHeatMeterStart)
        this.dryingHeatMeterStart = parseFloat(batch.dryingHeatMeterStart) > 0 ? parseFloat(batch.dryingHeatMeterStart) : ''
      //if (batch.dryingHeatMeterEnd)
        this.dryingHeatMeterEnd = parseFloat(batch.dryingHeatMeterEnd) > 0 ? parseFloat(batch.dryingHeatMeterEnd) : ''
      if (batch.driedStartDateTime) {
        this.setDriedStartDateTime(batch.driedStartDateTime)
      } else if (this.showDryingStartTime)
        this.setDriedStartDateTime()
      else {
        this.driedStartDate = ''
        this.driedStartTime = ''
      }
      //if (batch.driedStartMoisture)
        this.driedStartMoisture = parseFloat(batch.driedStartMoisture) > 0 ? batch.driedStartMoisture : ''
      //if (batch.driedMoundHeight)
        this.driedMoundHeight = parseFloat(batch.driedMoundHeight) > 0 ? batch.driedMoundHeight : ''
      //if (batch.driedMoisture)
        this.driedMoisture = parseFloat(batch.driedMoisture) > 0 ? batch.driedMoisture : ''
      //if (batch.driedHlWeight)
        this.driedHlWeight = parseFloat(batch.driedHlWeight) > 0 ? batch.driedHlWeight : ''
        this.driedSampleNumber = batch.driedSampleNumber

      this.dryerCleaned = batch.dryerCleaned === null ? true : parseInt(batch.dryerCleaned) === 1
      if (batch.driedDateTime) {
        this.setDriedDateTime(batch.driedDateTime)
      } else if (!this.showDryingStartTime || batch.driedStartDateTime)
        this.setDriedDateTime()
      else {
        this.driedDate = ''
        this.driedTime = ''
      }

      if (batch.driedComment) {
        this.noteData.text = batch.driedComment
      } else if (!this.dryingDryerId && batch.comment) {
        const comment = batch.comment.find(comment => comment.workflowState == 30)
        if (comment) this.noteData.text = comment.comment
      }

      this.vessel_regraterId = this.$props.batch.regraterId
      await this.getFillableVessels()
    },
    getWetVessels() {
      // console.log('getwetvessels from props',this.$props.bags)
      let bags = [];
      for (let idx in this.$props.bags) {
        if (this.$props.bags[idx].workflowState == 1) {
          bags.push(this.$props.bags[idx])
        }
      }
      return bags
    },
    getDryVessels() {
      // console.log('getdryvessels',this.dryingDryerId, this.$props.bags, this.dryVessels, this.batch)
      let bags = [];
      if (this.dryingDryerId > 0 && this.dryVessels) {
        for (let vessel of this.dryVessels) {
          if (vessel.workflowState >= 2) {

            if (this.$props.dryingDryerId > 0 && vessel.dryerId != this.$props.dryingDryerId)
              continue

            bags.push(vessel)
          }
        }
      } else {
        let allBags = this.$props.bags
        if (!allBags.length && this.dryVessels)
          allBags = this.dryVessels

        for (let idx in allBags) {
          if (allBags[idx].workflowState >= 2) {

            if (this.$props.dryingDryerId > 0 && allBags[idx].dryerId != this.$props.dryingDryerId)
              continue

            bags.push(allBags[idx])
          }
        }
      }
      return bags
    },
    async loadDryVessels() {
      this.dryVessels = await this.$store.dispatch('getItemsByParent', {
        entityName: 'vessel', parentEntity: 'batch',
        parentId: this.batch.batchId, method: 'dried',
        returnData: true
      })
    },
    async getFillableVessels() {
      this.fillableVessels = await this.$store.dispatch('getItemsByParent', {
        entityName: 'vessel',
        method: 'fillable',
        parentEntity: 'regrater',
        parentId: this.vessel_regraterId,
        returnData: true
      })
    },
    parseNumber(number) {
      if (parseInt(number) != number)
        number = parseFloat(number)
      else
        number = parseInt(number)

      return number.toLocaleString('de-DE')
    },
    getChildVesselsText(vesselId) {
      let texts = []
      for (let idx in this.childVessels) {
        if (this.childVessels[idx].parent_vesselId == vesselId) {
          texts.push(this.childVessels[idx].uniqueNumber + ' ' + this.parseNumber(this.childVessels[idx].weight) + ' kg')
        }
      }

      if (texts.length > 0)
        return texts.join(', ')

      return null
    },
    saveForm() {
    },
    async saveBag() {
      let bag = {}

      if (this.$props.workflowStatus == 0) {
        bag = {
          weight: this.wetWeight,
          number: this.wetNumber,
          workflowState: 1
        }
      } else { // workflowStatus === 1
        bag = {
          weight: this.dryWeight,
          number: this.containerNumber > 0 ? this.containerNumber : this.dryNumber,
          isBigBag: this.containerNumber > 0 ? 0 : 1,
          workflowState: 2,
          regraterId: this.vessel_regraterId,
          dryerId: this.dryingDryerId,
          contractPressing: this.contractPressing,
        }
        if (this.scaleData.response) {
          bag.driedWeighingResult = this.scaleData.response
          bag.driedWeighingNumber = this.scaleData.number
          bag.driedWeighingTimestamp = this.scaleData.timestamp
          bag.driedWeightTara = this.dryWeightTara
          bag.driedWeightBrutto = this.dryWeightBrutto
        }
      }
      bag['batchId'] = this.batch.batchId
      bag['parent_vesselId'] = this.parent_vesselId

      if (this.driedSampleNumber)
        bag['driedSampleNumber'] = this.$props.batch.driedSampleNumber = this.driedSampleNumber
      if (this.driedMoisture)
        bag['driedMoisture'] = this.$props.batch.driedMoisture = this.driedMoisture
      if (this.driedHlWeight)
        bag['driedHlWeight'] = this.$props.batch.driedHlWeight = this.driedHlWeight

      if (this.showStockLocation)
        bag['stockLocation'] = this.stockLocation

      const response = await this.$store.dispatch('cruItem',
          {name: 'vessel', data: bag, parentEntity: 'batch', parentId: this.batch.batchId})

      if (response && response.success === true) {
        this.wetNumber = ''
        this.wetWeight = ''
        this.dryWeight = ''
        this.dryWeightTara = ''
        this.dryWeightBrutto = ''
        this.dryNumber = ''
        this.containerNumber = ''
        this.stockLocation = ''
        this.contractPressing = false

        if (this.$props.workflowStatus === 0)
          await this.getWashed()
        else {
          if (this.dryingDryerId > 0) await this.loadDryVessels()
          else this.getDried()

          await this.getFillableVessels()
        }
      }

      if (this.getDryVessels().length === 1) {
        this.setDriedDateTime()
      }

      this.vessel_parentForm = false
      this.parent_vesselId = ''
      // this.$store.dispatch('createBag', {batchId: this.$props.batch.id, bag}).then(this.checkIfBagged.bind(this))
    },
    async getWashed() {
      const resultSet = await this.$store.dispatch('getItemsByParent', {
        entityName: 'vessel', parentEntity: 'batch',
        parentId: this.batch.batchId, method: 'washed',
        returnData: true,
      })
      console.log('getwashed', resultSet)
      this.$emit('updatedVessels', {data: resultSet})
    },
    getDried() {
      this.$store.dispatch('getItemsByParent', {
        entityName: 'vessel', parentEntity: 'batch',
        parentId: this.batch.batchId, method: 'dried'
      })
    },

    // washing
    setWashedStartDateTime(datetime) {
      if (datetime) {
        const customParseFormat = require('dayjs/plugin/customParseFormat')
        dayjs.extend(customParseFormat)
        this.washedStartDate = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY')
        this.washedStartTime = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')
      } else {
        this.washedStartDate = dayjs().format('DD.MM.YYYY')
        this.washedStartTime = dayjs().format('HH:mm')
      }
    },
    setWashedDateTime(datetime) {
      if (datetime) {
        const customParseFormat = require('dayjs/plugin/customParseFormat')
        dayjs.extend(customParseFormat)
        this.washedDate = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY')
        this.washedTime = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')
      } else {
        this.washedDate = dayjs().format('DD.MM.YYYY')
        this.washedTime = dayjs().format('HH:mm')
      }
    },
    async storeWashing() {
      this.washingStored = false
      let data = {}

      if (this.showWashingTime)
        data = {
          ...data,
          washedStartDate: this.washedStartDate,
          washedStartTime: this.washedStartTime,
          washedDate: this.washedDate,
          washedTime: this.washedTime,
          washedSystemCleaned: this.washedSystemCleaned,
          washedContainersCleaned: this.washedContainersCleaned,
        }

      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id: this.batch.batchId, data})

      if (response && response.success) {
        this.washingStored = true
      }
    },
    totalWeight(workflowStatus, formatted) {
      let total = 0;
      let bags;

      if (this.dryingDryerId > 0) {
        bags = this.getDryVessels()
      } else if (workflowStatus == 1) {
        bags = this.$props.bags.filter(bag => bag.workflowState == 1)
      } else
        bags = this.$props.bags.filter(bag => bag.workflowState >= 2)

      if (this.dryingDryerId > 0)
        bags = bags.filter(bag => bag.dryerId == this.dryingDryerId)

      for (let idx in bags) {
          total += parseFloat(bags[idx].weight)
      }

      if (formatted === false)
        return total

      return this.globalFunctions.parseNumber(total)
    },
    async finishWashing() {
      this.storing = true
      const data = {
        washedWeight: this.totalWeight(1, false),
        washedQuality: this.noteQuality,
        noteText: this.noteData.text,
        noteImages: this.noteData.images,
        // washedImage: this.$refs.camera.files[0],
        finishWashing: true,
      }
      if (this.showBatchSampleNumber)
        data.sampleNumber = this.sampleNumber

      const response = await this.$store.dispatch('uploadItem',
          {name: 'batch', id: this.batch.batchId, data})

      this.storing = false
      if (response && response.success) {
        this.$props.batch.washedQuality = this.noteQuality
        // this.$props.batch.washedImage = this.noteImage
        this.$props.batch.washedWeight = this.totalWeight(1, false)

        if (response.workflowState) {
          this.$props.batch.workflowState = response.workflowState
          this.$props.batch.workflowStatus = 1
        }

        this.$emit('finishedWashing');
        // todo scroll to top
      }
      // this.$props.workflowStatus = 1
    },
    saveWashed() {
      // prevent-function to activate browser validation for input fields
    },

    // drying
    vesselsOnDryer() {
      if (!this.$props.dryingDryerId)
        return []

      const vessels = [...this.$props.wetVessels]

      console.log('vesselsOnDryer', this.$props.wetVessels, this.$props.dryingDryerId, vessels, vessels.length)
      return vessels.filter(v => v.dryerId == this.$props.dryingDryerId)
    },
    vesselsToDry() {
      console.log('vesselsToDry', this.$props.wetVessels, this.$props.dryingDryerId, this.$props.wetVessels.filter(v => !v.dryerId))
      return this.$props.wetVessels.filter(v => !v.dryerId)
    },
    async addVesselToDryer() {
      const data = {
        dryerId: this.$props.dryingDryerId
      }
      const response = await this.$store.dispatch('cruItem',
          {name: 'vessel', id: this.wetVesselId, data})

      if (response && response.success) {
        console.log('addVesselToDryer', this.wetVesselId, this.$props.wetVessels.find(item => item.vesselId == this.wetVesselId))
        console.log('vorher', this.$props.wetVessels.find(item => item.vesselId == this.wetVesselId).dryerId)
        this.$props.wetVessels.find(item => item.vesselId == this.wetVesselId).dryerId = this.$props.dryingDryerId
        console.log('nachher', this.$props.wetVessels.find(item => item.vesselId == this.wetVesselId).dryerId)
      }
    },
    setDriedStartDateTime(datetime) {
      if (datetime) {
        const customParseFormat = require('dayjs/plugin/customParseFormat')
        dayjs.extend(customParseFormat)
        this.driedStartDate = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY')
        this.driedStartTime = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')
      } else {
        this.driedStartDate = dayjs().format('DD.MM.YYYY')
        this.driedStartTime = dayjs().format('HH:mm')
      }
    },
    setDriedDateTime(datetime) {
      if (datetime) {
        const customParseFormat = require('dayjs/plugin/customParseFormat')
        dayjs.extend(customParseFormat)
        this.driedDate = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('DD.MM.YYYY')
        this.driedTime = dayjs(datetime + ' +00:00', 'YYYY-MM-DD HH:mm:ss Z').format('HH:mm')
      } else {
        this.driedDate = dayjs().format('DD.MM.YYYY')
        this.driedTime = dayjs().format('HH:mm')
      }
    },
    saveDried() {
      // prevent-function to activate browser validation for input fields
    },
    async storeDrying(resetStoring = true) {
      this.storing = true
      this.dryingStored = false
      const data = {
        dryingDryerId: this.$props.dryingDryerId,
        dryerId: this.dryerId,
        driedMoisture: this.driedMoisture,
        driedHlWeight: this.driedHlWeight,
        driedDate: this.driedDate,
        driedTime: this.driedTime,
        driedSampleNumber: this.driedSampleNumber,
        dryerCleaned: this.dryerCleaned,
        noteText: this.noteData.text,
        noteImages: this.noteData.images,
        vesselIds: this.vesselsOnDryer().map(v => v.vesselId),
      }

      // add optional fields
      if (this.showDryingTemperature)
        data.dryingTemperature = this.dryingTemperature
      if (this.showDryingHeatMeter) {
        data.dryingHeatMeterStart = this.dryingHeatMeterStart
        data.dryingHeatMeterEnd = this.dryingHeatMeterEnd
      }
      if (this.showDriedMoundHeight)
        data['driedMoundHeight'] = this.driedMoundHeight
      if (this.showDryingStartTime) {
        data['driedStartDate'] = this.driedStartDate
        data['driedStartTime'] = this.driedStartTime
      }
      if (this.showDryingStartMoisture)
        data['driedStartMoisture'] = this.driedStartMoisture

      const response = await this.$store.dispatch('uploadItem',
          {name: 'batch', id: this.batch.batchId, data})

      if (resetStoring)
        this.storing = false
      if (response && response.success) {
        this.dryingStored = true
        this.$emit('storedDrying')
      }
    },
    async finishDrying() {
      await this.storeDrying(false)

      let dryingDryerId = this.$props.dryingDryerId

      if (!dryingDryerId) {
        if (!dryingDryerId && this.dryersAmount > 1) {
          dryingDryerId = this.dryerId
        } else {
          dryingDryerId = 1
        }
      }

      const data = {
        dryingDryerId,
        dryerId: this.dryerId,
        driedMoisture: this.driedMoisture,
        driedHlWeight: this.driedHlWeight,
        driedDate: this.driedDate,
        driedTime: this.driedTime,
        driedSampleNumber: this.driedSampleNumber,
        dryerCleaned: this.dryerCleaned,
        // driedWeight: this.totalWeight(2, false),
        workflowStatus: 3,
        vesselIds: this.vesselsOnDryer().map(v => v.vesselId),
      }

      this.$props.batch.driedSampleNumber = this.driedSampleNumber
      this.$props.batch.driedMoisture = this.driedMoisture
      this.$props.batch.driedHlWeight = this.driedHlWeight

      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id: this.batch.batchId, data})

      this.storing = false
      if (response && response.success) {
        const totalWeight = this.totalWeight(2, false)

        if (this.$props.dryingDryerId) {
          this.$emit('finishedDrying', {
            driedWeight: totalWeight,
            workflowState: response.workflowState,
          });
        } else {
          this.$props.batch.driedWeight = totalWeight
          if (response.workflowState)
            this.$props.batch.workflowState = response.workflowState
        }
      }
      // this.$props.batch.bagged = true
    },
    async finishFilling() {
      const data = {
        finishWorkflowStep: this.workflowState,
      }
      if (this.driedSampleNumber)
        data.driedSampleNumber = this.$props.batch.driedSampleNumber = this.driedSampleNumber
      if (this.driedMoisture)
        data.driedMoisture = this.$props.batch.driedMoisture = this.driedMoisture
      if (this.driedHlWeight)
        data.driedHlWeight = this.$props.batch.driedHlWeight = this.driedHlWeight

      const response = await this.$store.dispatch('cruItem',
          {name: 'batch', id: this.batch.batchId, data})

      if (response && response.success) {
        this.$emit('finishedWorkflowStep', { data: {
            workflowState: response.workflowState,
          }});
      }
    },

    openedPdf(params) {
      if (params.method === 'bigbagslip') {
        const vessel = this.$props.bags.find(vessel => vessel.uniqueId == params.elementId)
        vessel.openedBigBagSlip = 1
      }
    },
    openDialog({element, nbr, weight, uid}) {
      this.modalText = 'Soll ' + element + ' gelöscht werden?'
      this.modalElement = nbr + ' mit ' + this.parseNumber(weight) + ' kg'
      this.modalOpened = true
      this.modalUid = uid
    },
    abortDialog() {
      this.modalOpened = false
    },
    async confirmDialog() {
      this.modalOpened = false
      await this.$store.dispatch('delItem', {name: 'vessel', uid: this.modalUid})
      await this.$store.dispatch('getItemsByParent',
          {entityName: 'vessel', parentEntity: 'batch', parentId: this.batch.batchId})

      // delete from props
      const bagIndex = this.$props.bags.findIndex(bag => bag.uniqueId === this.modalUid);
      if (bagIndex !== -1) {
        this.$props.bags.splice(bagIndex, 1);
      }
    },
    checkIfBagged() {
      // let bagsWeight = 0
      //
      // for(let i in this.$props.batch.bags) {
      //   bagsWeight += this.$props.batch.bags[i].weight
      // }
      //
      // if (bagsWeight === this.$props.batch.dryWeight) {
      //   this.$props.batch.bagged = true
      // }
    },
    openCamera(e) {
      e.preventDefault()
      this.$refs.camera.click()
      // this.scrollToTop()
    },
    onFileChange(e) {
      const file = e.target.files[0];
      this.noteImage = URL.createObjectURL(file);
    },
    resetPhoto(e) {
      e.preventDefault()
      this.noteImage = null
    },
    // big bag popup editor
    editBag(bag) {
      this.bagElement = bag
      this.bagEditorOpened = true
    },
    abortBagEdit() {
      this.bagElement = null
      this.bagEditorOpened = false
    },
    async saveBagEdit({id, weight, regraterId, stockLocation, number, contractPressing}) {
      let data = {
        weight, regraterId, number, contractPressing
      }
      if (this.showStockLocation)
        data['stockLocation'] = stockLocation

      const response = await this.$store.dispatch('cruItem',
          {name: 'vessel', id, data: data})

      if (response && response.success === true) {
        this.bagElement.weight = weight
        this.bagElement.regraterId = regraterId
        this.bagElement.stockLocation = stockLocation
        this.bagElement.number = number
        this.bagElement.contractPressing = contractPressing
        this.abortBagEdit()
        await this.loadDryVessels()
      }
    },
    regraterName(contactId) {
      const regrater = this.$store.state.regrater.find(regrater => regrater.contactId == contactId)

      if (regrater) return regrater.name
      else return null
    },
    showBarcodeReader() {
      this.barcode = true
      window.scroll(0, 0); // todo: set popup correctly to prevent scroll
    },
    barcodeRead(params) {
      this.wetNumber = params.qrString
      this.barcode = false
      const element = this.$refs.wetVesselNumber
      element.scrollIntoView({ behavior: 'auto' })
    },
    async getWeightFromBbScale() {
      this.scaleData.output = 'Verbinde. Warte auf Antwort...'
      const result = await getWeightFromScale(this.$store.getters.scaleBbType, this.scaleBbHost, this.$store)

      if (result.error)
        this.scaleData.error = result.error
      else {
        this.dryWeight = result.weighingResult.netto
        this.dryWeightTara = result.weighingResult.tara
        this.dryWeightBrutto = result.weighingResult.brutto
        this.scaleData = {
          output: 'Gewicht von Waage eingelesen.',
          response: result.weighingResult.response,
          number: result.weighingResult.number,
          timestamp: result.weighingResult.timestamp,
        }
      }

      if (this.dryWeightBrutto - this.dryWeightTara !== this.dryWeight)
        this.scaleData.error = 'Achtung: Rundungsfehler bei Waage. <b>Korrektes Netto-Gewicht: '+
            this.parseNumber(this.dryWeightBrutto - this.dryWeightTara) +' kg</b>'+
            'Von Waage: '+ result.weighingResult.response
      // console.log(result)
    },
    getBbBarcodeNumber() {
      this.scanBbBarcode = true
      window.scrollTo({ top: 0})
    },
    bbBarcodeRead(params) {
      this.dryNumber = params.qrString.substring(1)
      this.scanBbBarcode = false
      this.scrollToElement('crud-vessels')
    },
    scrollToElement(id) {
      console.log('scrollToElement', id, document.getElementById(id))
      document.getElementById(id)?.scrollIntoView({
        behavior: 'smooth',
        block: 'start',
      })
    },
  },
  watch: {
    /*batch: {
      handler(newVal, oldVal) {
        console.log('Batch changed:', {
              newVal: newVal.dryerId,
              oldVal: oldVal?.dryerId
            });

        if (newVal.dryerId !== oldVal?.dryerId || oldVal == undefined) {
          // todo check if old changed-data is stored
          this.initDryingData()
          //this.getDryVessels()
        }
      },
      deep: true, // Set to true if you want to watch nested changes
      immediate: false // Trigger the handler immediately after the component is created
    }
    currentDryerId(newVal, oldVal) {
      console.log('Dryer ID changed:', { newVal, oldVal });

      if (newVal !== oldVal) {
        this.initDryingData();
      }
    }*/
    dryingDryerId: {
      handler(newVal, oldVal) {
        console.log('Dryer ID changed:', {newVal, oldVal}, this.dryerId, this.$props.dryingList);

        if (this.$props.dryingList)
          this.initDryingData(this.$props.dryingList.find(item => item.dryerId == newVal))
        if (this.$props.batch && !newVal && this.dryerId)
          this.initDryingData(this.$props.batch)
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>

<style scoped>
.w55 {
  flex: 0 0 55%;
  max-width: 55%;
}

.w45 {
  flex: 0 0 45%;
  max-width: 45%;
}

details summary h2 {
  font-family: inherit;
  border-bottom-width: 1px;
}
</style>